{{value}}
<valg-dk-bar-chart *ngIf="percentage !== undefined" [percentage]="percentage" [class]="breakpoint" [ngClass]="['d-block']" [showNumber]="false"></valg-dk-bar-chart>
<span *ngIf="description" class="expanded-details text--normal text--small mt-2">
    {{ description }}
</span>